import { render, staticRenderFns } from "./SwitchAccountsConfirm.vue?vue&type=template&id=0afb093b"
import script from "./SwitchAccountsConfirm.vue?vue&type=script&lang=js"
export * from "./SwitchAccountsConfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports